import { Injectable } from '@angular/core';
import { EnvDomainVariables } from './env.service';
@Injectable({
  providedIn: 'root',
})
export class EnvCDSSProdService {
  getDomainInfo(): EnvDomainVariables {
    return {
      _enableErrorLogging: false,
      isMagellan: '0',
      _env: 'cdss-prod',
      _apiUrl: 'https://app3-api.p-cis.com/api/',
      _production: true,
      _redirectUri: 'https://app3-login.p-cis.com/',
      _responseType: 'token id_token',
      _issuer: 'https://cdssprodadb2c.b2clogin.com/d376878c-84d8-47bb-aced-18d6df874824/v2.0/',
      _strictDiscoveryDocumentValidation: false,
      _tokenEndpoint: 'https://cdssprodadb2c.b2clogin.com/pcisadb2c.onmicrosoft.com/oauth2/v2.0/token?p=b2c_1_signin',
      _loginUrl: 'https://cdssprodadb2c.b2clogin.com/cdssprodadb2c.onmicrosoft.com/oauth2/v2.0/token?p=B2C_1_Signin',
      _clientId: '950bd5bc-465f-49ce-815c-0aae265a9bac',
      _scope: 'openid profile https://cdssprodadb2c.onmicrosoft.com/api/cdss.read',
      _skipIssuerCheck: true,
      _clearHashAfterLogin: true,
      _oidc: true,
      _logoutUrl: 'https://cdssprodadb2c.b2clogin.com/cdssprodadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/logout?post_logout_redirect_uri=https://app3-login.p-cis.com/',
      _signInURL: 'https://cdssprodadb2c.b2clogin.com/cdssprodadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_signin_signup_frp',
      _signInURLSSO: 'https://cdssprodadb2c.b2clogin.com/cdssprodadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_SIGNUP_FRP_SSO',
      _adb2cTenantUrl: 'https://cdssprodadb2c.b2clogin.com/cdssprodadb2c.onmicrosoft.com/oauth2/v2.0/',
      _magicLink: 'https://cdssprodadb2c.b2clogin.com/cdssprodadb2c.onmicrosoft.com/v2.0/.well-known/openid-configuration?p=B2C_1A_SIGNIN_WITH_EMAIL',
      _oktaClientId: '0oag4pjnccJymdJVS1d7',
      _oktaIssuer: 'https://child-welfare-digital-services.oktapreview.com/oauth2/ausg4pw2f3vLM5mwV1d7',
      _oktaRedirectUri: 'https://app3-login.p-cis.com/auth/okta/callback',
      _authEndpoint: 'https://cdssprodadb2c.b2clogin.com/cdssprodadb2c.onmicrosoft.com/B2C_1A_signin_signup_frp/oauth2/v2.0/authorize',
      _magicLinkScope : 'https://cdssprodadb2c.b2clogin.com/cdssprodadb2c.onmicrosoft.com/B2C_1A_SIGNIN_WITH_EMAIL/oauth2/v2.0/authorize',
      _launchDarklyClientId: '69120006711aa209b78d9ab0',
      _intercomAppId: 'bqgvwybf'
  
    };
  }
}
